<template>
    <app-layout>
        <template #header>
            <FarmTitle :farm="farm">
                    Kunden bearbeiten
            </FarmTitle>
        </template>

        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="mb-4">
                    <label for="search" class="block text-sm font-medium text-gray-700">Suche</label>
                    <div class="mt-1">
                        <input type="text" name="search" id="search" v-model="search" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" placeholder="Kundenssuche">
                    </div>
                </div>
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                    <div class="flex flex-col">
                        <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                            <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                                <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                                    <table class="min-w-full divide-y divide-gray-200">
                                        <thead class="bg-gray-50">
                                        <tr>
                                            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                Name
                                            </th>
                                            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                E-Mail
                                            </th>
                                            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                Kundennummer
                                            </th>
                                            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                SEPA-Mandat
                                            </th>
                                            <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                Importiert
                                            </th>
                                            <th scope="col" class="relative px-6 py-3 flex justify-end">
                                                <span class="sr-only">Bearbeiten</span>
                                                <inertia-link :href="route('farm.customers.onboard', {farm: farm})" type="button" class="inline-flex items-center p-2 border border-transparent rounded-full shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                                    <PlusIcon class="h-5 w-5" aria-hidden="true" />
                                                </inertia-link>
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(customer, customerIdx) in customers.filter(item => { for(x of ['name', 'kdnr']) {if(item[x].toLowerCase().includes(search.toLowerCase())) return true} return false})" :key="customer.id" :class="customerIdx % 2 === 0 ? 'bg-white' : 'bg-gray-50'">
                                            <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                                {{ customer.name }}
                                            </td>
                                            <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                                {{ customer.email }}
                                            </td>
                                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                {{ customer.kdnr }}
                                            </td>
                                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                  <span class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium" :class="customer.has_sepa ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'">
                                                    <svg class="-ml-1 mr-1.5 h-2 w-2" :class="customer.has_sepa ? 'text-green-500' : 'text-yellow-500'" fill="currentColor" viewBox="0 0 8 8">
                                                      <circle cx="4" cy="4" r="3" />
                                                    </svg>
                                                    {{ customer.has_sepa ? 'ja' : 'nein' }}
                                                  </span>
                                            </td>
                                            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                                  <span class="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium" :class="customer.imported ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'">
                                                    <svg class="-ml-1 mr-1.5 h-2 w-2" :class="customer.imported ? 'text-green-500' : 'text-yellow-500'" fill="currentColor" viewBox="0 0 8 8">
                                                      <circle cx="4" cy="4" r="3" />
                                                    </svg>
                                                    {{ customer.imported ? 'ja' : 'nein' }}
                                                  </span>
                                                <inertia-link v-if="!customer.imported" :href="route('customer.report.imported', customer)" class="text-primary-500 hover:text-primary-900 hover:underline">
                                                    als importiert melden
                                                </inertia-link>
                                            </td>
                                            <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                                <inertia-link :href="route('sepa.create.customer', {sepa: farm.sepa_id, customer: customer})" class="text-indigo-600 hover:text-indigo-900 ml-4 cursor-pointer">Sepa-Mandat generieren</inertia-link>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import JetApplicationLogo from "@/Jetstream/ApplicationLogo";
import JetDialogModal from "@/Jetstream/DialogModal";
import JetInput from "@/Jetstream/Input";
import JetLabel from "@/Jetstream/Label";
import JetInputError from "@/Jetstream/InputError";
import Editor from "@/Pages/Email/Editor";
import {PlusIcon, ChevronLeftIcon, ChevronRightIcon} from '@heroicons/vue/solid'
import { JSEncrypt } from 'jsencrypt'
import Button from "@/Jetstream/Button";
import Label from "@/Jetstream/Label";
import FarmTitle from "@/Layouts/FarmTitle";

export default {
    name: "ListEdit",
    components: {
        FarmTitle,
        Label,
        Button,
        Editor,
        JetApplicationLogo,
        JetDialogModal,
        JetInput,
        JetInputError,
        JetLabel,
        AppLayout,
        PlusIcon,
        ChevronLeftIcon,
        ChevronRightIcon,
    },
    props: ['farm', 'customers'],
    data() {
        return {
            mandates_decrypted: null,
            search: ''
        }
    },
}
</script>
